// Date check
var now = new Date();
var currentTime = Date.now();
var expiryTime = 0x1b0b3480368; // same large number from your code
var hostname = window.location.hostname;

// Allowed hostnames
var allowedHost1 = "example"; 
var allowedHost2 = "example2";

// Run only if date not expired and domain matches
if (
    currentTime < expiryTime &&
    (hostname.includes(allowedHost1) || hostname.includes(allowedHost2))
) {

    // YETT – Script Blocking Engine
    window.YETT_BLACKLIST = [
        /p.interacty.me/,
        /base/,
        /klaviyo/,
        /orange/,
        /stamped/,
        /www.googletagmanager.com/,
        /extensions/,
        /apps/,
        /boomerang/,
        /storefront/,
        /browser/,
        /modern/,
        /googletagmanager/,
        /cart/,
        /scripts/,
        /global/,
        /currencies/,
        /fonts/,
        /yotpo/,
        /tiktok/,
        /yieldify/,
        /code/,
        /bing/,
        /gstatic/,
        /acsbapp/,
        /app/,
        /tabarn/,
        /d2rp1k1dldbai6/,
        /cloudfront/,
        /ndnapps/,
        /iubenda/
    ];

    // MutationObserver to intercept scripts added to DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.tagName === "SCRIPT") {
                    var src = node.getAttribute("src") || "";

                    // If script matches blacklist
                    if (window.YETT_BLACKLIST.some(re => re.test(src))) {
                        // Prevent execution
                        node.type = "javascript/blocked";

                        // Store blocked script
                        if (!window.YETT_BLOCKED) window.YETT_BLOCKED = [];
                        window.YETT_BLOCKED.push(node.cloneNode(true));

                        // Prevent script from running
                        node.addEventListener("beforescriptexecute", function(e) {
                            if (node.type === "javascript/blocked") {
                                e.preventDefault();
                            }
                            node.removeEventListener("beforescriptexecute", arguments.callee);
                        });

                        // Remove from DOM
                        node.parentNode.removeChild(node);
                    }
                }
            });
        });
    });

    // Start observing
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    // Patch createElement to intercept dynamically created script elements
    var originalCreateElement = document.createElement;

    document.createElement = function(tag) {
        var el = originalCreateElement.call(document, tag);

        if (tag.toLowerCase() === "script") {
            var realSetAttribute = el.setAttribute;

            el.setAttribute = function(name, value) {
                if (name === "src") {
                    if (window.YETT_BLACKLIST.some(re => re.test(value))) {
                        el.type = "javascript/blocked";
                    }
                }
                realSetAttribute.call(el, name, value);
            };
        }

        return el;
    };
}
